import { render, staticRenderFns } from "./BaseFormNumberField.vue?vue&type=template&id=1a9eba7e"
import script from "./BaseFormNumberField.vue?vue&type=script&lang=js"
export * from "./BaseFormNumberField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports